__webpack_require__.p = "/sales_management/";